import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CatalogState } from './catalog.reducer';

export const catalogKey: string = 'catalog';

export const selectCatalogState = createFeatureSelector<CatalogState>(catalogKey);

export const getCatalogList = createSelector(selectCatalogState, (state: CatalogState) => state.list);

export const getCurrentCatalog = createSelector(selectCatalogState, (state: CatalogState) => state.current);

export const getCurrentCatalogPages = createSelector(
    selectCatalogState,
    (state: CatalogState) => state.current?.pages || []
);

export const getCatalogIsSaving = createSelector(selectCatalogState, (state: CatalogState) => state.isSaving);
